(() => {
  const clean = value => String(value || '').trim().toLowerCase();

  const removePlaceholderDimensionTabs = () => {
    document.querySelectorAll('[data-pb-panel="dimensions-fit"]').forEach(panel => {
      const rte = panel.querySelector('.pb-product-info-tabs__rte, .rte');
      if (clean(rte?.textContent) !== 'placeholder') return;

      const wrapper = panel.closest('[data-pb-product-info-tabs]') || document;
      const button = wrapper.querySelector('[data-pb-tab-target="dimensions-fit"]');
      button?.remove();
      panel.remove();

      const remainingButton = wrapper.querySelector('[data-pb-tab-target]');
      const remainingPanel = wrapper.querySelector('[data-pb-panel]');
      if (remainingButton && !wrapper.querySelector('[data-pb-tab-target].is-active')) {
        remainingButton.classList.add('is-active');
        remainingButton.setAttribute('aria-selected', 'true');
        remainingButton.setAttribute('tabindex', '0');
      }
      if (remainingPanel && !wrapper.querySelector('[data-pb-panel][open]')) remainingPanel.setAttribute('open', '');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removePlaceholderDimensionTabs, { once: true });
  } else {
    removePlaceholderDimensionTabs();
  }
})();